module.exports = __webpack_public_path__ + "static/media/apti_sphp_logo.596ab0c7.jpg";